
const strIsEmpty = function(str) {
  if(!str || typeof(str) == 'undefined' || str=='' || str==null)
    return true
  else
    return false
};

const objIsNull = function(obj) {
  if(!obj || typeof(obj) == 'undefined' || obj=='' || obj==null)
    return true
  else
    return false
};

const numIsValid = function(num) {
  if(!num || typeof(num) == 'undefined' || num==null || num<=0)
    return false
  else
    return true
};

const listIsEmpty = function(list) {
  if(!list || typeof(list) == 'undefined' || list==null || list.length==0)
    return true
  else
    return false
};

const boolIsTrue = function(flag) {
  if(!flag || typeof(flag) == 'undefined' || flag==null)
    return false
  else
    return true
};

export { strIsEmpty,
        objIsNull,
        numIsValid,
        listIsEmpty,
        boolIsTrue
      }